import React from 'react'
import PgaCoachProgramsPage from '@layouts/pga-coach-search/programs-page'
import { getPgaCoachProgramsPageInitialProps } from '@lib/pga-coach/get-programs-page-initial-props'

function GolfLessonsPage(props) {
  return <PgaCoachProgramsPage {...props} />
}

GolfLessonsPage.getInitialProps = getPgaCoachProgramsPageInitialProps

export default GolfLessonsPage
